import { ICopyable } from '../controls/common/icopyable';
import { IContact } from './interfaces/contact.interface';
import { IDisplayableItem } from './interfaces/displayable-item.interface';

export class Contact implements ICopyable<Contact>, IDisplayableItem {
    public id: number = null;
    public organizationId: string = null;
    public lastName: string = null;
    public firstName: string = null;
    public email: string = null;
    public mobileNumber: string = null;
    public companyName: string = null;

    public createCopy(): Contact {
        const instance = new Contact();
        instance.id = this.id;
        instance.organizationId = this.organizationId;
        instance.lastName = this.lastName;
        instance.firstName = this.firstName;
        instance.email = this.email;
        instance.mobileNumber = this.mobileNumber;
        instance.companyName = this.companyName;

        return instance;
    }

    public static createFormCopy(contact: Contact): IContact {
        const instance = new Contact();
        instance.id = contact.id;
        instance.organizationId = contact.organizationId;
        instance.lastName = contact.lastName;
        instance.firstName = contact.firstName;
        instance.email = contact.email;
        instance.mobileNumber = contact.mobileNumber;
        instance.companyName = contact.companyName;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.organizationId = other.organizationId;
        this.lastName = other.lastName;
        this.firstName = other.firstName;
        this.email = other.email;
        this.mobileNumber = other.mobileNumber;
        this.companyName = other.companyName;
    }

    public getDisplayName() {
        return `${this.email}`;
    }

    get displayName(): string {
        return `${this.email}`;
    }
}
